/** @format */

import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
	Component,
	DestroyRef,
	OnInit,
	PLATFORM_ID,
	computed,
	inject,
	input,
	output,
	signal
} from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconRecommendationFire
} from '@dsg-tech/homefield-angular-icons';
import {
	ProductSocialContentState,
	SocialContentService,
	setProductSocialContentState
} from '@social-content/data-access';

import { BreakPointNew } from '@shared/data-access/enums';
import { BreakpointsService } from '@shared/utils/services';
import { Environment } from '@shared/data-access/interfaces';
import { Store } from '@ngrx/store';
import { selectProductReviewCount } from '@product-reviews/data-access';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'pdp-hot-on-social-button',
	standalone: true,
	imports: [CommonModule, HomefieldIconLibraryModule],
	styleUrl: './hot-on-social-button.component.scss',
	templateUrl: './hot-on-social-button.component.html'
})
export class HotOnSocialButtonComponent implements OnInit {
	seoUrl = input.required<string>();
	buttonClick = output<void>();
	socialContentService = inject(SocialContentService);
	environment = inject(Environment);
	platFormId = inject(PLATFORM_ID);
	breakPointsService = inject(BreakpointsService);

	private readonly destroyRef = inject(DestroyRef);

	store: Store<ProductSocialContentState> = inject(Store);

	isMobileSize = computed(() => this.breakPointsService.breakpoint() <= BreakPointNew.MEDIUM);

	shouldShowButton = signal(false);

	hasReviews = signal(false);

	private readonly reviewCount$ = this.store.select(selectProductReviewCount);

	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconRecommendationFire]);
	}

	ngOnInit(): void {
		if (isPlatformBrowser(this.platFormId)) {
			const productUrl = `${this.environment.thirdParty.bv.socialApi.brandDomains.dsg}${this.seoUrl()}`;
			this.socialContentService
				.getSocialContentByProductUrl$(productUrl)
				.subscribe((response) => {
					this.shouldShowButton.set(!!response.resultsCount);
					this.store.dispatch(
						setProductSocialContentState({
							items: response.items,
							resultsCount: response.resultsCount
						})
					);
				});
		}

		this.reviewCount$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((reviewCount) => {
			this.hasReviews.set(!!reviewCount);
		});
	}

	onClick(): void {
		this.buttonClick.emit();
	}
}
